// 디자인 시스템 컴포넌트 통합 export
import CardDefault from './Card';

export { default as Button } from './Button';
export type { ButtonProps } from './Button';

export { default as Input } from './Input';
export type { InputProps } from './Input';

export const Card = CardDefault;
export const CardHeader = CardDefault.Header;
export const CardContent = CardDefault.Content;
export const CardFooter = CardDefault.Footer;
export const CardTitle = CardDefault.Title;
export type {
  CardProps,
  CardHeaderProps,
  CardContentProps,
  CardFooterProps,
  CardTitleProps,
} from './Card';

export { default as Alert } from './Alert';
export type { AlertProps } from './Alert';

export { default as Label } from './Label';
export type { LabelProps } from './Label';

export { default as Textarea } from './Textarea';
export type { TextareaProps } from './Textarea';

export { default as Switch } from './Switch';
export type { SwitchProps } from './Switch';

export { default as Badge } from './Badge';
export type { BadgeProps } from './Badge';

export { Tabs, TabsList, TabsTrigger, TabsContent } from './Tabs';
export type { TabsProps, TabsListProps, TabsTriggerProps, TabsContentProps } from './Tabs';

// 스타일과 상수들도 같이 export
export * from '../../styles/theme';
export * from '../../styles/constants';
